import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/info-red.svg'
import _imports_1 from '@/app/ui/assets/svg/plus-circle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-0fed95a3")

_pushScopeId("data-v-0fed95a3")
const _hoisted_1 = { class: "flex flex-row border border-gray-lp-200 rounded-2xl w-full mt-2" }
const _hoisted_2 = { class: "w-1/2 border-r border-gray-lp-200 p-4 flex flex-col gap-2 bg-gray-lp-1000 rounded-l-2xl" }
const _hoisted_3 = { class: "flex flex-row gap-1 items-center font-bold text-black-lp-100" }
const _hoisted_4 = { class: "flex flex-row gap-2" }
const _hoisted_5 = { class: "w-32 h-32 rounded-xl border border-gray-lp-200 relative" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "absolute top-0 left-0 w-full h-full opacity-50 rounded-xl bg-black" }, null, -1)
const _hoisted_7 = { class: "flex flex-row items-center gap-1" }
const _hoisted_8 = {
  class: "underline text-white font-semibold",
  style: {"font-size":"9.33px"}
}
const _hoisted_9 = { class: "list-decimal ml-5" }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "flex flex-row items-center justify-center py-3 pl-8 gap-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("img", {
            src: _imports_0,
            alt: _ctx.$t('cargoV2.components.photoDispute.infoAlt')
          }, null, 8, ["alt"]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("cargoV2.components.photoDispute.title")), 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("img", {
              src: require(`@/app/ui/assets/svg/guide-photo-one.svg`),
              class: "object-cover h-full rounded-xl",
              alt: "result-image"
            }, null, 8, ["src"]),
            _hoisted_6,
            _createVNode("button", {
              "data-testid": "cargo-v2-dispute-photo-view-guide",
              class: "absolute bottom-1 right-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previewPhotoGuide && _ctx.previewPhotoGuide(...args)))
            }, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Icons, {
                  name: "eye-preview",
                  class: "text-white h-3 w-3",
                  style: {"height":"13.33px"}
                }),
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("cargoV2.components.photoDispute.viewPhoto")), 1)
              ])
            ])
          ]),
          _createVNode("ol", _hoisted_9, [
            _createVNode("li", _hoisted_10, _toDisplayString(_ctx.$t("cargoV2.components.photoDispute.guide.clearPhoto")), 1),
            _createVNode("li", _hoisted_11, _toDisplayString(_ctx.$t("cargoV2.components.photoDispute.guide.readableWeightVolume")), 1),
            _createVNode("li", _hoisted_12, _toDisplayString(_ctx.$t("cargoV2.components.photoDispute.guide.fullCargoFrame")), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.proofPhotos, (photo, index) => {
          return (_openBlock(), _createBlock(_component_UploadImageTiny, {
            key: photo.id,
            "data-testid": "cargo-v2-dispute-photo-slot-required",
            class: "photo-card",
            accept: "image/png, image/jpg, image/jpeg",
            widthContentCard: _ctx.proofPhotos.length > 2 ? 'w-24' : '',
            titleSize: "10",
            title: photo?.desc,
            modelValue: _ctx.modelValue[index],
            "onUpdate:modelValue": ($event: any) => (_ctx.modelValue[index] = $event),
            maxSize: 5,
            multipleIndex: index,
            defaultImage: _ctx.modelValue[index],
            onUpload: _ctx.onUpload,
            onRemove: _ctx.onRemove,
            onPreview: () => _ctx.onPreview(index)
          }, null, 8, ["widthContentCard", "title", "modelValue", "onUpdate:modelValue", "multipleIndex", "defaultImage", "onUpload", "onRemove", "onPreview"]))
        }), 128)),
        (_ctx.proofPhotos.length < _ctx.maxPhoto)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onAddImage && _ctx.onAddImage(...args))),
              src: _imports_1,
              alt: "plus-circle-red",
              class: "w-5 h-5 ml-4 cursor-pointer"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ImagePreview, {
      modelValue: _ctx.preview,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.preview = $event)),
      data: _ctx.imagePreviews,
      isTerm: false,
      single: _ctx.single,
      image: _ctx.image
    }, null, 8, ["modelValue", "data", "single", "image"])
  ], 64))
})